import { analiticaInstance } from 'shared/analitica'

import { type LucyLogger } from '../types'

export function createLucyDatadogLogger(userId?: string): LucyLogger {
  const lucyDatadogEvents = analiticaInstance.eventFactory('LucyChat', {
    chat: {
      log: (label: string, metadata?: Record<string, unknown>) => ({
        label,
        metadata: metadata ?? {},
        filterPlugins: ['DATADOG']
      })
    }
  })

  function sendToDatadog(message: string, metadata?: Record<string, unknown>) {
    lucyDatadogEvents.events.chat.log(message, { ...metadata, user: { id: userId } })
  }

  return {
    v: (message, attributes) => sendToDatadog(message, attributes),
    d: (message, attributes) => sendToDatadog(message, attributes),
    i: (message, attributes) => sendToDatadog(message, attributes),
    w: (message, attributes) => sendToDatadog(message, attributes),
    e: (message, error, errorInfo, attributes) =>
      sendToDatadog(message, {
        ...attributes,
        error: error ?? undefined,
        errorName: error?.name,
        errorCode: errorInfo?.code,
        errorFatal: errorInfo?.fatal
      })
  }
}
